// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';

@Component({
  selector:    'lm-compound-field',
  templateUrl: './lm-compound-field.component.html',
  styleUrls:   [ 'lm-compound-field.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMCompoundFieldComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {

  @HostBinding('class.hide-labels') hideLabels = false;

  @Input() layoutObject: LMCompoundFieldLayout;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  // error TS2610: 'parentCompoundFieldDisplayOnly' is defined as an accessor in class 'LMFieldBaseComponent'
  // @Input() parentCompoundFieldDisplayOnly: boolean;

  @HostBinding('class.preview-field') @Input() previewMode = false;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  @Output() fieldEvent: EventEmitter<LMFieldEvent> = new EventEmitter<LMFieldEvent>();

  public elements: LMFormLayoutElements;
  public launchButtonTooltip: string;
  public paragraphLayout: LMParagraphLayoutInfo = {};
  public memberFieldFocused = false;
  public showCompactDialogButton = false;

  constructor(protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFieldServiceAdapter);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);
    this.elements = this.lmFieldServiceAdapter.lmCompoundFieldService.flattenLayout(this.specField.layout);
    this.subscribeToInlineError();
    this.launchButtonTooltip = Soho.Locale.translate('Launch');

    if (this.lmColumnLayoutInfo) {
      this.lmColumnLayoutInfo.parentIsCompoundField = true;
    }

    if (this.previewMode) {
      this.paragraphLayout.previewMode = true;
      this.paragraphLayout.displayAsText = true;
      this.paragraphLayout.displayOnly = true;
      this.hideLabels = true;
    }
	
	if (this.specField.compactFormat && !this.specField.compactFormatOnly) {
      this.showCompactDialogButton = true;
    }

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;

    // validity conditions listen for evaluateConditions notification
    if (this.layoutObject.validity) {
      this.subscriptionArray.push(
        this.lmFieldServiceAdapter.lmConditionUtilService.evaluateConditions.subscribe( () => {
          this.recalculateReadOnly();
          this.parentCompoundFieldDisplayOnly = this.isReadOnly;
        })
      );
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onMemberFieldError(message) {
    this.compoundFieldInError = true;
    this.model.setFieldError(this.bindId, message);
  }

  onFieldEvent(event: LMFieldEvent) {
    if (event.eventType === 'MemberFocusEvent') {
      this.memberFieldFocused = true;
    } else if (event.eventType === 'MemberBlurEvent') {
      this.memberFieldFocused = false;
    } else {
      super.onFieldEvent(event);
    }
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  }

  openCompactDialog(event) {
    this.onContextMenuEvent({args: [event.currentTarget]});
  }
}
